'use client';

import { useEffect } from 'react';
import { usePaywall } from '@/app_lib/providers/PaywallProvider';

export const Paywall = () => {
  const {
    paywallState: { paywallCheck },
  } = usePaywall();

  useEffect(() => {
    const paywallRef = document.querySelector('.paywall');

    if (paywallCheck === 'paywalled' && paywallRef) {
      paywallRef.classList.add('paywallActive');
      const hasRelatedVideo = document.querySelector('#related-video');
      if (!hasRelatedVideo) {
        document.querySelector('.paywall-selector')?.classList.add('paywallFade');
      }
    } else if (paywallCheck !== 'paywalled' && paywallRef) {
      paywallRef.classList.remove('paywallActive');

      document.querySelector('.paywall-selector')?.classList.remove('paywallFade');
    }
  }, [paywallCheck]);
  return null;
};
